import { AppSegmentType } from 'src/api/globalTypes';

import { heapTracking } from './heap';

export function track(segment: AppSegmentType) {
  heapTracking(segment);
}
